<template>
  <ImportUsersModal
    cancelText="cancel"
    :handleCancel="handleCancel"
    :handleMainActionSuccess="handleMainActionSuccess"
    :handleViewChange="handleViewChange"
    :headerIcon="headerIcon"
    :headerSubtext="headerSubtext"
    :headerText="headerText"
    :hideCloseAction="hideCloseAction"
    :hideResultsMainAction="hideResultsMainAction"
    :importType="`scim:${item.displayName}`"
    :itemType="itemType"
    :resultsDisclaimerText="disclaimerText"
    :resultsJobId="resultsJobId"
    :resultsMainActionText="resultsMainActionText"
    :showResultsView="showResultsView"
    :subTextUnderTitle="true"
    :useHeaderIconStyleClass="false"
    :visible="true"
  >
    <template
      v-slot:selectionComponent="slotProps"
    >
      <ScimUsersImportSelection
        :appConnectionType="idmConnectionType"
        :scimAppId="scimAppId"
        :scimAppSourceName="applicationImportSourceName"
        :tableImportConditions="slotProps.tableImportConditions"
      />
    </template>
    <template
      v-slot:toBeImportedUsersCounter
    >
      <ScimToBeImportedUserCount />
    </template>
  </ImportUsersModal>
</template>

<script>
import {
  ImportUsersConsts,
  ItemTypeConsts,
  StoreModelMap,
} from 'client/util/Constants';
import { PERSONIO, scimConnectionTypes } from 'client/util/Constants/ApplicationConstants';
import { getApplicationImportSourceName } from 'client/applications/utils/ApplicationUtils';
import { mapState } from 'vuex';
import ApplicationAvatar from 'client/applications/ApplicationAvatar.vue';
import CloudDirectoryImportMixin from 'client/directories/mixins/CloudDirectoryImportMixin';
import ImportUsersModal from 'client/components/ImportUsers/ImportUsersModal.vue';
import ScimToBeImportedUserCount from 'client/applications/import/ScimToBeImportedUserCount';
import ScimUsersImportSelection from 'client/applications/import/ScimUsersImportSelection';

const { application } = ItemTypeConsts;
const ApplicationModel = StoreModelMap[application];
const { results } = ImportUsersConsts.views;
const { scimUsersImportSubHeaderTexts } = ImportUsersConsts;
const { resultsHeaderSubtext, bulkResultsHeaderSubtext } = scimUsersImportSubHeaderTexts;
const { CUSTOM } = scimConnectionTypes;

export default {
  name: 'ScimUsersImport',

  components: {
    ImportUsersModal,
    ScimToBeImportedUserCount,
    ScimUsersImportSelection,
  },

  mixins: [CloudDirectoryImportMixin],

  props: {
    resultsJobId: {
      type: String,
      default: '',
    },
    scimAppId: {
      type: String,
      required: true,
    },
    showResultsView: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hideCloseAction: false,
      hideResultsMainAction: false,
      itemType: ItemTypeConsts.scimUserImport,
    };
  },

  computed: {
    ...mapState(ApplicationModel, [
      'item',
      'scimConnectionType',
    ]),
    applicationImportSourceName() {
      const { item, scimConnectionType } = this;
      return getApplicationImportSourceName(item, scimConnectionType);
    },
    disclaimerText() {
      return this.getDisclaimer(this.item.displayName);
    },
    headerIcon() {
      return ApplicationAvatar;
    },
    headerSubtext() {
      return {
        selectionHeaderSubtext: `Select the users you want to import from ${this.item.displayName} into JumpCloud.`,
        resultsHeaderSubtext,
        bulkResultsHeaderSubtext,
      };
    },
    headerText() {
      return `Import Users from ${this.item.displayName}`;
    },

    idmConnectionType() {
      // Maps a certain application with an arbitrary connection type
      const connectionTypeMap = {
        [PERSONIO]: CUSTOM,
      };
      return connectionTypeMap[this.item.displayName] || this.scimConnectionType;
    },
  },

  methods: {
    handleViewChange(view) {
      if (view === results) {
        this.hideCloseAction = true;
        this.hideResultsMainAction = true;
      }
    },
  },
};
</script>
